import React from 'react';

const UserDataContext = React.createContext({});

 
export default UserDataContext;